module.exports = __webpack_public_path__ + "static/media/left.173051a0.svg";